// src/routes.js
import React from "react";
import {
  MdHome,
  MdPerson,
  MdDashboard,
  MdGroup,
  MdHistory,
  MdLocalOffer,
  MdPayment,
  MdAccountBalanceWallet,
  MdAttachMoney,
  MdAccountBalance,
  MdVerifiedUser,
  MdStar,
} from "react-icons/md";

// Lazy load components to avoid circular dependencies
const Dashboard = React.lazy(() => import("views/admin/default"));
const ProfileOverview = React.lazy(() => import("views/admin/profile"));
const AdminIncomeDashboard = React.lazy(() => import("views/admin/income"));
const UserTable = React.lazy(() => import("views/admin/users/components/UserTable"));
const UserPayments = React.lazy(() => import("views/admin/payments"));
const AdminWithdrawals = React.lazy(() => import("views/admin/AdminWithdrawals"));
const BankVerification = React.lazy(() => import("views/admin/BankVerification"));
const KycVerification = React.lazy(() => import("views/admin/KycVerification"));
const SignIn = React.lazy(() => import("views/auth/SignIn"));
const SignUp = React.lazy(() => import("views/auth/SignUp"));
const ForgotPassword = React.lazy(() => import("views/auth/ForgotPassword"));
const VerifyOtp = React.lazy(() => import("views/auth/VerifyOtp"));
const ResetPassword = React.lazy(() => import("views/auth/ChangePassword"));
const ChangePassword = React.lazy(() => import("views/auth/ChangePassword"));
const MemberDashboard = React.lazy(() => import("views/member"));
// const IncomeHistory = React.lazy(() => import("views/member/IncomeHistory")); // ⚠️ COMMENTED OUT - Not needed currently
const Referrals = React.lazy(() => import("views/member/Referrals"));
const Pricing = React.lazy(() => import("views/member/pricing/Pricing"));
const Wallet = React.lazy(() => import("views/member/Wallet"));
const Withdrawal = React.lazy(() => import("views/member/Withdrawal"));
const AdminRewards = React.lazy(() => import("views/admin/rewards"));

export const authRoutes = [
  {
    name: "Sign In",
    layout: "/auth",
    path: "sign-in",
    component: SignIn,
  },
  {
    name: "Sign Up",
    layout: "/auth",
    path: "sign-up",
    component: SignUp,
  },
  {
    name: "Forgot Password",
    layout: "/auth",
    path: "forgot-password",
    component: ForgotPassword,
    hidden: true,
  },
  {
    name: "Verify OTP",
    layout: "/auth",
    path: "verify-otp",
    component: VerifyOtp,
    hidden: true,
  },
  {
    name: "Reset Password",
    layout: "/auth",
    path: "reset-password",
    component: ResetPassword,
    hidden: true,
  },
  {
    name: "Change Password",
    layout: "/auth",
    path: "change-password",
    component: ChangePassword,
    hidden: true,
  },
];


// ---------------- Admin Routes ----------------
export const adminRoutes = [
  {
    name: "Dashboard",
    layout: "/admin",
    path: "default",
    icon: <MdHome className="h-6 w-6" />,
    component: Dashboard,
  },
  {
    name: "Users",
    layout: "/admin",
    path: "users",
    icon: <MdPerson className="h-6 w-6" />,
    component: UserTable,
  },
  {
    name: "User Payments",
    layout: "/admin",
    path: "payments",
    icon: <MdPayment className="h-6 w-6" />,
    component: UserPayments,
  },
  {
    name: "Income Dashboard",
    layout: "/admin",
    path: "income",
    icon: <MdAttachMoney className="h-6 w-6" />,
    component: AdminIncomeDashboard,
  },
  {
    name: "Withdrawals",
    layout: "/admin",
    path: "withdrawals",
    icon: <MdAccountBalance className="h-6 w-6" />,
    component: AdminWithdrawals,
  },
  {
    name: "Bank Verification",
    layout: "/admin",
    path: "bank-verification",
    icon: <MdAccountBalanceWallet className="h-6 w-6" />,
    component: BankVerification,
  },
  {
    name: "KYC Verification",
    layout: "/admin",
    path: "kyc-verification",
    icon: <MdVerifiedUser className="h-6 w-6" />,
    component: KycVerification,
  },
  {
    name: "Rewards",
    layout: "/admin",
    path: "rewards",
    icon: <MdStar className="h-6 w-6" />,
    component: AdminRewards,
  },
  {
    name: "Profile",
    layout: "/admin",
    path: "profile",
    icon: <MdPerson className="h-6 w-6" />,
    component: ProfileOverview,
    hidden: true, // Hide from sidebar menu
  },
];

// ---------------- Member Routes ----------------
export const memberRoutes = [
  {
    name: "Dashboard",
    layout: "/member",
    path: "dashboard",
    icon: <MdDashboard className="h-6 w-6" />,
    component: MemberDashboard,
  },
  {
    name: "My Referrals",
    layout: "/member",
    path: "referrals",
    icon: <MdGroup className="h-6 w-6" />,
    component: Referrals,
  },
  {
    name: "My Package",
    layout: "/member",
    path: "pricing",
    icon: <MdLocalOffer className="h-6 w-6" />,
    component: Pricing,
  },
  {
    name: "My Wallet",
    layout: "/member",
    path: "wallet",
    icon: <MdAccountBalanceWallet className="h-6 w-6" />,
    component: Wallet,
  },
  {
    name: "Withdrawal",
    layout: "/member",
    path: "withdrawal",
    icon: <MdAccountBalance className="h-6 w-6" />,
    component: Withdrawal,
  },
  // ⚠️ INCOME HISTORY ROUTE - COMMENTED OUT (Not needed currently)
  // To re-enable: Uncomment this route AND uncomment the IncomeHistory.jsx file
  // {
  //   name: "Income History",
  //   layout: "/member",
  //   path: "income-history",
  //   icon: <MdHistory className="h-6 w-6" />,
  //   component: IncomeHistory,
  // },
  {
    name: "Profile",
    layout: "/member",
    path: "profile",
    icon: <MdPerson className="h-6 w-6" />,
    component: ProfileOverview,
  },

];
